import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trigger", "nativeTriggerButton", "openOnHover", "delay", "closeDelay", "title", "description", "children", "onClose", "open", "defaultOpen", "handle", "onOpenChange", "side", "align", "sideOffset", "initialFocus", "anchor", "id", "ariaLabel", "ariaLabelledby", "ariaDescribedby", "ariaDescription", "dataTestId", "dataAttributes", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef, cloneElement } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { pickDataAttributes } from '../../utils/pickDataAttributes';
import { PopoverRoot, PopoverClose, PopoverContent, PopoverDescription, PopoverTitle, PopoverTrigger } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PopoverInner(t0, ref) {
  var _id, _ariaLabel, _ariaLabelledby, _ariaDescribedby, _ariaDescription, _dataTestId, _ariaDescribedby2, _ariaDescription2, _ariaLabel2, _ariaLabelledby2, _dataTestId2, _id2;
  const $ = _c(63);
  let T0;
  let align;
  let anchor;
  let ariaDescribedby;
  let ariaDescription;
  let ariaLabel;
  let ariaLabelledby;
  let children;
  let dataAttributes;
  let dataTestId;
  let description;
  let id;
  let initialFocus;
  let onClose;
  let side;
  let sideOffset;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let title;
  if ($[0] !== ref || $[1] !== t0) {
    const {
        trigger,
        nativeTriggerButton,
        openOnHover,
        delay,
        closeDelay,
        title: t6,
        description: t7,
        children: t8,
        onClose: t9,
        open,
        defaultOpen,
        handle,
        onOpenChange,
        side: t10,
        align: t11,
        sideOffset: t12,
        initialFocus: t13,
        anchor: t14,
        id: t15,
        ariaLabel: t16,
        ariaLabelledby: t17,
        ariaDescribedby: t18,
        ariaDescription: t19,
        dataTestId: t20,
        dataAttributes: t21
      } = t0,
      restProps = _objectWithoutPropertiesLoose(t0, _excluded);
    title = t6;
    description = t7;
    children = t8;
    onClose = t9;
    side = t10;
    align = t11;
    sideOffset = t12;
    initialFocus = t13;
    anchor = t14;
    id = t15;
    ariaLabel = t16;
    ariaLabelledby = t17;
    ariaDescribedby = t18;
    ariaDescription = t19;
    dataTestId = t20;
    dataAttributes = t21;
    T0 = PopoverRoot;
    t1 = defaultOpen;
    t2 = handle;
    t3 = onOpenChange;
    t4 = open;
    t5 = trigger != null && /*#__PURE__*/_jsx(PopoverTrigger, {
      ref: ref,
      closeDelay: closeDelay,
      delay: delay,
      nativeButton: nativeTriggerButton,
      openOnHover: openOnHover,
      render: /*#__PURE__*/cloneElement(trigger, restProps)
    });
    $[0] = ref;
    $[1] = t0;
    $[2] = T0;
    $[3] = align;
    $[4] = anchor;
    $[5] = ariaDescribedby;
    $[6] = ariaDescription;
    $[7] = ariaLabel;
    $[8] = ariaLabelledby;
    $[9] = children;
    $[10] = dataAttributes;
    $[11] = dataTestId;
    $[12] = description;
    $[13] = id;
    $[14] = initialFocus;
    $[15] = onClose;
    $[16] = side;
    $[17] = sideOffset;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = title;
  } else {
    T0 = $[2];
    align = $[3];
    anchor = $[4];
    ariaDescribedby = $[5];
    ariaDescription = $[6];
    ariaLabel = $[7];
    ariaLabelledby = $[8];
    children = $[9];
    dataAttributes = $[10];
    dataTestId = $[11];
    description = $[12];
    id = $[13];
    initialFocus = $[14];
    onClose = $[15];
    side = $[16];
    sideOffset = $[17];
    t1 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    title = $[23];
  }
  const t6 = (_id = id) === null || _id === void 0 ? void 0 : _id.root;
  const t7 = (_ariaLabel = ariaLabel) === null || _ariaLabel === void 0 ? void 0 : _ariaLabel.root;
  const t8 = (_ariaLabelledby = ariaLabelledby) === null || _ariaLabelledby === void 0 ? void 0 : _ariaLabelledby.root;
  const t9 = (_ariaDescribedby = ariaDescribedby) === null || _ariaDescribedby === void 0 ? void 0 : _ariaDescribedby.root;
  const t10 = (_ariaDescription = ariaDescription) === null || _ariaDescription === void 0 ? void 0 : _ariaDescription.root;
  let t11;
  if ($[24] !== dataAttributes) {
    t11 = pickDataAttributes(dataAttributes);
    $[24] = dataAttributes;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = (_dataTestId = dataTestId) === null || _dataTestId === void 0 ? void 0 : _dataTestId.root;
  let t13;
  if ($[26] !== title) {
    t13 = title != null && /*#__PURE__*/_jsx(PopoverTitle, {
      children: title
    });
    $[26] = title;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== description) {
    t14 = description != null && /*#__PURE__*/_jsx(PopoverDescription, {
      children: description
    });
    $[28] = description;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== ((_ariaDescribedby2 = ariaDescribedby) === null || _ariaDescribedby2 === void 0 ? void 0 : _ariaDescribedby2.closeButton) || $[31] !== ((_ariaDescription2 = ariaDescription) === null || _ariaDescription2 === void 0 ? void 0 : _ariaDescription2.closeButton) || $[32] !== ((_ariaLabel2 = ariaLabel) === null || _ariaLabel2 === void 0 ? void 0 : _ariaLabel2.closeButton) || $[33] !== ((_ariaLabelledby2 = ariaLabelledby) === null || _ariaLabelledby2 === void 0 ? void 0 : _ariaLabelledby2.closeButton) || $[34] !== ((_dataTestId2 = dataTestId) === null || _dataTestId2 === void 0 ? void 0 : _dataTestId2.closeButton) || $[35] !== ((_id2 = id) === null || _id2 === void 0 ? void 0 : _id2.closeButton) || $[36] !== onClose) {
    var _ariaLabel3, _id3, _ariaLabelledby3, _ariaDescribedby3, _ariaDescription3, _dataTestId3, _ariaDescribedby4, _ariaDescription4, _ariaLabel4, _ariaLabelledby4, _dataTestId4, _id4;
    t15 = onClose != null && /*#__PURE__*/_jsx(PopoverClose, {
      onClick: onClose,
      "aria-label": (_ariaLabel3 = ariaLabel) === null || _ariaLabel3 === void 0 ? void 0 : _ariaLabel3.closeButton,
      id: (_id3 = id) === null || _id3 === void 0 ? void 0 : _id3.closeButton,
      "aria-labelledby": (_ariaLabelledby3 = ariaLabelledby) === null || _ariaLabelledby3 === void 0 ? void 0 : _ariaLabelledby3.closeButton,
      "aria-describedby": (_ariaDescribedby3 = ariaDescribedby) === null || _ariaDescribedby3 === void 0 ? void 0 : _ariaDescribedby3.closeButton,
      "aria-description": (_ariaDescription3 = ariaDescription) === null || _ariaDescription3 === void 0 ? void 0 : _ariaDescription3.closeButton,
      "data-test-id": (_dataTestId3 = dataTestId) === null || _dataTestId3 === void 0 ? void 0 : _dataTestId3.closeButton,
      children: unescapedText("trellis-components.popover.closeButton.label")
    });
    $[30] = (_ariaDescribedby4 = ariaDescribedby) === null || _ariaDescribedby4 === void 0 ? void 0 : _ariaDescribedby4.closeButton;
    $[31] = (_ariaDescription4 = ariaDescription) === null || _ariaDescription4 === void 0 ? void 0 : _ariaDescription4.closeButton;
    $[32] = (_ariaLabel4 = ariaLabel) === null || _ariaLabel4 === void 0 ? void 0 : _ariaLabel4.closeButton;
    $[33] = (_ariaLabelledby4 = ariaLabelledby) === null || _ariaLabelledby4 === void 0 ? void 0 : _ariaLabelledby4.closeButton;
    $[34] = (_dataTestId4 = dataTestId) === null || _dataTestId4 === void 0 ? void 0 : _dataTestId4.closeButton;
    $[35] = (_id4 = id) === null || _id4 === void 0 ? void 0 : _id4.closeButton;
    $[36] = onClose;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== align || $[39] !== anchor || $[40] !== children || $[41] !== initialFocus || $[42] !== side || $[43] !== sideOffset || $[44] !== t10 || $[45] !== t11 || $[46] !== t12 || $[47] !== t13 || $[48] !== t14 || $[49] !== t15 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t16 = /*#__PURE__*/_jsxs(PopoverContent, Object.assign({
      id: t6,
      "aria-label": t7,
      "aria-labelledby": t8,
      "aria-describedby": t9,
      "aria-description": t10
    }, t11, {
      "data-test-id": t12,
      side: side,
      align: align,
      sideOffset: sideOffset,
      initialFocus: initialFocus,
      anchor: anchor,
      children: [t13, t14, children, t15]
    }));
    $[38] = align;
    $[39] = anchor;
    $[40] = children;
    $[41] = initialFocus;
    $[42] = side;
    $[43] = sideOffset;
    $[44] = t10;
    $[45] = t11;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
    $[49] = t15;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== T0 || $[56] !== t1 || $[57] !== t16 || $[58] !== t2 || $[59] !== t3 || $[60] !== t4 || $[61] !== t5) {
    t17 = /*#__PURE__*/_jsxs(T0, {
      defaultOpen: t1,
      handle: t2,
      onOpenChange: t3,
      open: t4,
      children: [t5, t16]
    });
    $[55] = T0;
    $[56] = t1;
    $[57] = t16;
    $[58] = t2;
    $[59] = t3;
    $[60] = t4;
    $[61] = t5;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  return t17;
}
PopoverInner.displayName = 'PopoverInner';

/**
 * `Popover` configured from a `trigger` element, flat `title`, `description`,
 * and `children` content props, and an `onClose` callback that renders a managed
 * close button, so you don't compose `PopoverTrigger`, `PopoverContent`,
 * `PopoverTitle`, `PopoverDescription`, and `PopoverClose` by hand.
 *
 * @see {@link PopoverRoot | Popover}
 */
export const Popover = /*#__PURE__*/forwardRef(PopoverInner);
Popover.displayName = 'Popover';